// extracted by mini-css-extract-plugin
export default {"loader-container":"Loader_loader-container__N34cp","app-logo":"Loader_app-logo__0vzqm","spinner":"Loader_spinner__B+YTX","spin-anim":"Loader_spin-anim__ONh65"};